export function LossLedgerTable({ ledger }) {
  if (!ledger) return null;
  const total = ledger.reduce((s, r) => s + (r.value_per_day || 0), 0);
  return (
    <div className="space-y-1" data-testid="loss-ledger-table">
      {ledger.map((row, i) => (
        <div key={row.mechanism} className="flex items-center justify-between py-1.5 border-b border-[var(--oim-border)]" data-testid={`loss-ledger-row-${i}`} data-mechanism-testid={`ledger-row-${row.mechanism.replace(/[^a-zA-Z]/g, "-")}`}>
          <span className="text-xs text-[var(--oim-text-secondary)]">{row.mechanism}</span>
          <div className="flex items-center gap-3">
            {row.unavailable ? (
              <span className="text-[9px] font-heading uppercase px-1.5 py-0.5 rounded-full border border-[var(--oim-border)] text-[var(--oim-text-dim)]" data-testid={`loss-ledger-badge-${i}`}>UNAVAILABLE</span>
            ) : Math.round(row.value_per_day) === 0 ? (
              <span className="text-[9px] font-heading uppercase px-1.5 py-0.5 rounded-full border" style={{ borderColor: "var(--oim-green)", color: "var(--oim-green)" }} data-testid={`loss-ledger-badge-${i}`}>NO LOSS DETECTED</span>
            ) : (
              <span className="font-mono-data text-xs text-[var(--oim-text)]" data-testid={`loss-ledger-badge-${i}`}>₹{Math.round(row.value_per_day).toLocaleString("en-IN")}/day</span>
            )}
          </div>
        </div>
      ))}
      <div className="flex items-center justify-between pt-2 font-mono-data text-sm font-semibold">
        <span className="text-[var(--oim-text)]">Total attributed</span>
        <span className="text-[var(--oim-text)]">₹{Math.round(total).toLocaleString("en-IN")}/day</span>
      </div>
    </div>
  );
}
